export default "/images/ledger.png?4af4a7ab823c4e43341ce5cc151aaa74";